
import {merge as observableMerge, Observable, BehaviorSubject} from 'rxjs';

import {map} from 'rxjs/operators';
import {
  Component , ElementRef , EventEmitter , Input , OnChanges , OnInit , Output , ViewChild ,
  ViewChildren
} from '@angular/core';
import {fuseAnimations} from '../../../../../core/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {FusePerfectScrollbarDirective} from '../../../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import {DataSource} from '@angular/cdk/collections';
import {FuseUtils} from '../../../../../core/fuseUtils';

@Component({
    selector: 'eventAndRewards-tab',
    templateUrl: './eventAndRewards.html',
    styleUrls: ['./eventAndRewards.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class EventAndRewardsComponent implements OnChanges {

  @Input() eventList;
  @Input() rewards;

  displayedColumns = [ 'eventTitle' , 'eventType', 'credits', 'type', 'typeRewards', 'comment', 'action'  ];
  public filterData: any = {};
  users: FilesDataSource | null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;

  constructor () {

  }

  ngOnChanges () {
    if (this.eventList && this.rewards) {
      const data = {
        users: this.eventList.concat(this.rewards) ,
        onEventChanged: new BehaviorSubject({})
      };

      this.users = new FilesDataSource(data , this.paginator , this.sort);
    }
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private usersService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.usersService.users;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.usersService.onEventChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.usersService.users.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      switch (this._sort.active) {
        case 'color':
          [ propertyA , propertyB ] = [ a.event.eventType.color , b.event.eventType.color ];
          break;
        case 'eventTitle':
          [ propertyA , propertyB ] = [ a.event.title , b.event.title ];
          break;
        case 'type':
          [ propertyA , propertyB ] = [ a.event.eventType.name , b.event.eventType.name ];
          break;
        case 'credits':
          [ propertyA , propertyB ] = [ a.event.credits , b.event.credits ];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
